export default {
  errorCampaignNameEn: null,
  errorCampaignNameTh: null,
  errorCampaignBanner: null,
  errorBrandCode: null,
  errorStartDate: null,
  errorEndDate: null,
  errorStatus: null,
  errorPurchaseWindowDays: null,
  errorMinimumNetAmount: null,
  errorMaxSuccessfulRefereesPerCustomer: null,
  errorReferrerRewardPrivilegeId: null,
  errorRefereeRewardPrivilegeId: null,
  errorCampaignDetailEn: null,
  errorCampaignDetailTh: null,
  errorTermsAndConditionsEn: null,
  errorTermsAndConditionsTh: null,
  errorNotificationMessageTemplateRefereeOnAccept: null,
  errorNotificationMessageTemplateReferrerOnRewardIssued: null,
};
